module.exports = __webpack_public_path__ + "static/media/groceries.2bc0b6ff.svg";